import dotProp from 'dot-prop-immutable';

import Service from './Service';
import DialogService from './DialogService';
import {getStipsMode, hasStipsWelcomeScreenShown} from '-/util/util';
import {
    areThereStipsToResubmitSelector,
    allStipsSubmittedForApplicantSelector,
    allStipsSubmittedSelector,
    findImageData
} from '-/selectors';
import NavigationService from '-/services/NavigationService';

const STIPS_SETDATA = 'STIPS_SETDATA';
const STIPS_SET_IMAGE = 'STIPS_SET_IMAGE';
const STIPS_SET_APPLICANT_TYPE = 'STIPS_SET_APPLICANT_TYPE';
const STIPS_ADD_DOC = 'STIPS_ADD_DOC';
const STIPS_REMOVE_DOC = 'STIPS_REMOVE_DOC';
const STIPS_SETREF = 'STIPS_SETREF';

const reducerName = 'stips';

const initialState = {
    stipsData: {},
    stipsImages: {},
    applicantType: null
};

const getStipsIndex = (state, stipType) => {
    return state.stipsData[state.applicantType].stips.findIndex(stip => stip.stipType === stipType);
};

const reducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case STIPS_SETDATA:
            return dotProp.set(state, 'stipsData', payload.stipsData);
        case STIPS_SET_APPLICANT_TYPE:
            return dotProp.set(state, 'applicantType', payload.applicantType);
        case STIPS_SET_IMAGE: {
            const {docType, data, i} = payload;
            const key = `${docType}_${state.applicantType}_${i}`;
            state = dotProp.set(state, `stipsImages.${key}`, data);
            const dotPath = `stipsData.${state.applicantType}.stips.${getStipsIndex(state, docType)}.docs.${i}`;
            const doc = dotProp.get(state, dotPath);
            if (doc) {
                state = dotProp.merge(state, dotPath, {submitted: true});
            }
            return state;
        }
        case STIPS_SETREF: {
            const {stip, doc} = payload;
            doc.submitted = true;
            const dotPath = `stipsData.${state.applicantType}.stips.${getStipsIndex(state, stip.docType)}.docs`;
            const stipDocs = dotProp.get(state, dotPath);
            const indexOfDoc = stipDocs.findIndex(stipDoc => stipDoc._id === doc._id);
            state = dotProp.set(state, `${dotPath}.${indexOfDoc}`, doc);
            return state;
        }
        case STIPS_ADD_DOC: {
            const {docType, doc} = payload;
            const dotPath = `stipsData.${state.applicantType}.stips.${getStipsIndex(state, docType)}.docs`;
            const stipDocs = dotProp.get(state, dotPath);
            stipDocs.push(doc);
            return dotProp.set(state, dotPath, stipDocs);
        }
        case STIPS_REMOVE_DOC: {
            const {docType} = payload;
            const dotPath = `stipsData.${state.applicantType}.stips.${getStipsIndex(state, docType)}.docs.$end`;
            return dotProp.delete(state, dotPath);
        }
    }
    return state;
};

class StipsService extends Service {
    constructor() {
        super();

        if (!StipsService.instance) {
            StipsService.instance = this;
        }
        return StipsService.instance;
    }

    getReducerName() {
        return reducerName;
    }

    getReducer() {
        return reducer;
    }

    setPreviewImage(docType, data, i) {
        this.store.dispatch({
            type: STIPS_SET_IMAGE,
            payload: {
                docType,
                data,
                i
            }
        });
    }

    openDialog(data) {
        DialogService.show('StipDialog', data);
    }

    closeDialog() {
        DialogService.show(false);
    }

    setRef(stip, doc) {
        this.store.dispatch({
            type: STIPS_SETREF,
            payload: {
                stip,
                doc
            }
        });
    }

    setData(stipsData) {
        this.setApplicantType(getStipsMode());
        this.store.dispatch({
            type: STIPS_SETDATA,
            payload: {
                stipsData
            }
        });
    }

    setApplicantType(applicantType) {
        this.store.dispatch({
            type: STIPS_SET_APPLICANT_TYPE,
            payload: {
                applicantType
            }
        });
    }

    enter() {
        if (!this.showStatusPage()) {
            if (!this.showWelcomePage()) {
                if (!this.showResubmitPage()) {
                    NavigationService.next('stips');
                }
            }
        }
    }

    showStatusPage() {
        if (allStipsSubmittedSelector(this.getState())) {
            NavigationService.next('stipsStatus');
            return true;
        }
        return false;
    }

    showResubmitPage() {
        if (areThereStipsToResubmitSelector(this.getState())) {
            NavigationService.next('stipResubmit');
            return true;
        }
        return false;
    }

    showWelcomePage() {
        if (!hasStipsWelcomeScreenShown()) {
            NavigationService.next('stipsWelcome');
            return true;
        }
        return false;
    }

    addDoc(stip, doc) {
        const {docType} = stip;
        this.store.dispatch({
            type: STIPS_ADD_DOC,
            payload: {
                docType,
                doc
            }
        });
    }

    removeDoc(stip, indexOfDoc) {
        const {docType} = stip;
        this.store.dispatch({
            type: STIPS_REMOVE_DOC,
            payload: {
                docType
            }
        });
        if (findImageData(this.store.getState(), docType, indexOfDoc)) {
            this.setPreviewImage(docType, undefined, indexOfDoc);
        }
    }
}

export default new StipsService();
